import React,{useEffect, useState} from 'react'
import ScrollStory from '../sections/ScrollStory';
import LeadershipTeam from '../sections/LeadershipTeam';
import { useLocation } from 'react-router';
import { OrgMetaGet } from '../../api/orgService';
import useApi from '../../api/useApi';

function WhoWeAre() {

  const sections = document.querySelectorAll(".scroll-text > div");
    const stickyBox = document.getElementById("stickyBox");
    const location = useLocation();
    const [orgValues, setOrgValues] = useState([]);
    
    const { request: getAllMetaData, data:orgMetaData, error:orgMetaDataError,isLoading:metaDataLoading} = useApi(OrgMetaGet);
    
      
    
    // const [userScrolling, setUserScrolling] = useState(false);


    window.addEventListener("scroll", () => {
      sections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
          const heading = section.querySelector("h2").innerText;
          const img = section.getAttribute("data-img");
          stickyBox.innerText = heading;
          stickyBox.style.backgroundImage = img;
        }
      });
    });

    

    useEffect(() => {
      if (location.hash) {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [location]);

      const [content, setContent] = useState({
        title: "",
        text: "",
        img: "",
      });
  
  
    
        useEffect(() => {
            // console.log(partnerGetAllData)
            getAllMetaData(1)
            // eslint-disable-next-line
        }, []);
    
        useEffect(() => {
            // console.log(partnerGetAllData)
            if(orgMetaData?.data){
                const values = orgMetaData.data.org_metadata?.values || [];
            //  setOrgValues(orgMetaData?.data?.org_metadata?.values || []);
            setOrgValues([...values]);
            }
            // eslint-disable-next-line
        }, [orgMetaData]);
    
    
  return (
    <div className='global-center-column'>
      <div className='about-us' id='about-us'>
        <div className='about-us-header'>
          <h2>Fountain Africa Trust</h2>
        </div>
        
        <div className='about-us-intro'>

           {/* <!-- Right Column --> */}
           <div class="about-right">
              <p>              
              Fountain Africa Trust is a non-profit organization registered in Kenya in 2013 to empower community resilience among rural, under-served and marginalized populations in Kenya and beyond. Rooted in Christian faith and compassion, we believe every life holds equal value and deserves access to essential health services, dignity, and opportunity regardless of circumstances.
              </p>
              <p>
              Our work spans maternal and newborn health, disability inclusion, and community empowerment programs. Through partnerships with local midwives, health facilities, and community volunteers, we bring life-saving care directly to those who need it most. From upgrading newborn units in rural hospitals to supporting children with autism and empowering people with disabilities, we respond to urgent needs with transparency, accountability, and unwavering commitment to those we serve.
              </p>
          </div>
          <div class="about-left">
          {/* <small>About Us</small>
          <h2>Our Brief but rich <span>History</span></h2>
          <div class="underline"></div> */}
          </div>

         
      </div>
    </div>
      
    <div id='our-values' className='about-us-our-values'>
      <div className='about-us-our-values-header'>
          <h2>Our Values</h2>
      </div>
    </div>
    <div>
    <div className='about-us-scroll' >
    <ScrollStory ourValues={orgValues}/>
    </div>
    </div>

   

    <section  className="relative bg-gradient-to-b from-slate-50 via-white to-blue-50 py-20 px-6 md:px-20">
      {/* curved divider matching dark values section */}
      <svg
        className="absolute top-0 left-0 w-full -translate-y-1"
        viewBox="0 0 1440 320"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#0f172a"  /* matches the dark navy 'Values' background */
          d="M0,224L48,213.3C96,203,192,181,288,160C384,139,480,117,576,128C672,139,768,181,864,197.3C960,213,1056,203,1152,176C1248,149,1344,107,1392,85.3L1440,64V0H0Z"
        />
      </svg>

      <div id="our-mission" className="relative z-10 max-w-6xl mx-auto text-center mb-30">
        {/* Consistent heading style */}
        <h2 className="text-4xl md:text-5xl font-bold text-[#b96f63] mb-6">
          Our Mission & Vision
        </h2>
        {/* <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Guided by our shared values, our mission and vision define how we act —
          empowering communities, sustaining oceans, and inspiring a more balanced world.
        </p> */}
      </div>

      <div id="our-vision" className="grid md:grid-cols-2 gap-10 max-w-6xl mx-auto">
        {/* Mission */}
        <div className="bg-white shadow-lg rounded-2xl p-10 border-t-4 border-[#b96f63] hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold text-[#1D3A89] mb-4">
            Our Mission
          </h3>
          <p className="text-gray-700 leading-relaxed">
            To empower coastal and fishing communities through innovation,
            sustainable practices, and partnerships that preserve marine life while
            strengthening local livelihoods.
          </p>
        </div>

        {/* Vision */}
        <div className="bg-white shadow-lg rounded-2xl p-10 border-t-4 border-[#b96f63] hover:shadow-2xl transition-shadow duration-300">
          <h3 className="text-2xl font-semibold text-[#1D3A89] mb-4">
            Our Vision
          </h3>
          <p className="text-gray-700 leading-relaxed">
            To create a thriving future where people and oceans coexist in harmony —
            fostering resilience, equality, and sustainability across generations.
          </p>
        </div>
      </div>
    </section>

    <div className='about-us' id='our-leadership'>
    <div className='about-us-our-values'>
      <div className='about-us-our-values-header'>
          <h2>Our Leadership Team</h2>
      </div>
      <LeadershipTeam />
    </div>
    </div>
  </div>
  )
}

export default WhoWeAre


// import React, { useEffect, useRef, useState } from "react";
// import ScrollStory from '../sections/ScrollStory';

// function WhoWeAre() {
//   const scrollContainerRef = useRef(null);
//   const stickyBoxRef = useRef(null);
//   const [userScrolling, setUserScrolling] = useState(false);

//   useEffect(() => {
//     const scrollContainer = scrollContainerRef.current;
//     const sections = scrollContainer.querySelectorAll(".scroll-text > div");
//     const stickyBox = stickyBoxRef.current;

//     let animationFrame;
//     let scrollPosition = 0;
//     const scrollSpeed = 0.6; // adjust as needed

//     // Auto scroll logic
//     const autoScroll = () => {
//       if (!userScrolling && scrollContainer) {
//         scrollPosition += scrollSpeed;
//         scrollContainer.scrollTop = scrollPosition;
//         if (scrollPosition < scrollContainer.scrollHeight - scrollContainer.clientHeight) {
//           animationFrame = requestAnimationFrame(autoScroll);
//         }
//       }
//     };

//     // Observe sections and update sticky content
//     const handleScroll = () => {
//       sections.forEach((section) => {
//         const rect = section.getBoundingClientRect();
//         if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {
//           const heading = section.querySelector("h2")?.innerText || "";
//           const img = section.getAttribute("data-img");
//           stickyBox.innerText = heading;
//           stickyBox.style.backgroundImage = `url(${img})`;
//         }
//       });
//     };

//     // Start auto-scroll
//     animationFrame = requestAnimationFrame(autoScroll);

//     // Stop on user scroll/touch
//     const handleUserScroll = () => {
//       setUserScrolling(true);
//       cancelAnimationFrame(animationFrame);
//     };

//     scrollContainer.addEventListener("scroll", handleScroll);
//     scrollContainer.addEventListener("wheel", handleUserScroll, { passive: true });
//     scrollContainer.addEventListener("touchmove", handleUserScroll, { passive: true });

//     return () => {
//       cancelAnimationFrame(animationFrame);
//       scrollContainer.removeEventListener("scroll", handleScroll);
//       scrollContainer.removeEventListener("wheel", handleUserScroll);
//       scrollContainer.removeEventListener("touchmove", handleUserScroll);
//     };
//   }, [userScrolling]);

//   return (
//     <div className="global-center-column">
//       <div className="about-us" id="about-us">
//         <div className="about-us-header">
//           <h2>Fountain Africa Trust</h2>
//         </div>
//         <div className="about-us-intro">
//           <div className="about-right">
//             <p>
//               is a non-profit organization registered in Kenya in 2013 to empower community resilience among rural, under-served, and marginalized populations in Kenya and beyond.
//             </p>
//             <p>
//               Empowering resilience in rural, under-served, and marginalized communities across Kenya and beyond since 2013.
//             </p>
//           </div>
//           <div className="about-left"></div>
//         </div>
//       </div>

//       <div className="about-us-our-values">
//         <div className="about-us-our-values-header">
//           <h2>Our Values</h2>
//         </div>
//       </div>

//       <div className="about-us-scroll" id="our-values" ref={scrollContainerRef}>
//         <div id="stickyBox" ref={stickyBoxRef} className="sticky-box"></div>
//         <ScrollStory />
//       </div>

//       <div className="about-us" id="our-leadership">
//         <div className="about-us-header">
//           <h2>Our Leadership</h2>
//         </div>
//         <div className="about-us-intro">
//           <div className="about-right">
//             <p>
//               The Kenya Red Cross Society (KRCS) was founded in 1965 under the Kenya Red Cross Society Act and officially acknowledged by the Kenyan government as a voluntary aid society working alongside public authorities.
//             </p>
//             <p>
//               KRCS maintains independence, enabling it to operate in alignment with the Fundamental Principles of the Red Cross and Red Crescent Movement.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default WhoWeAre;
